"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_exports = {};
__export(query_exports, {
  MessagesQuery: () => MessagesQuery
});
module.exports = __toCommonJS(query_exports);
var import_communication_types = require("@hcengineering/communication-types");
var import_communication_sdk_types = require("@hcengineering/communication-sdk-types");
var import_communication_shared = require("@hcengineering/communication-shared");
var import_uuid = require("uuid");
var import_result = require("../result");
var import_types = require("../types");
var import_window = require("../window");
var import_utils = require("../utils");
class MessagesQuery {
  constructor(client, hulylake, id, params, options, callback, initialResult) {
    this.client = client;
    this.hulylake = hulylake;
    this.id = id;
    this.params = params;
    this.options = options;
    this.callback = callback;
    const limit = params.limit ?? import_types.defaultQueryParams.limit;
    this.params = {
      ...params,
      limit,
      order: params.order ?? import_types.defaultQueryParams.order
    };
    void this.subscribe();
    if (initialResult !== void 0) {
      const messages = initialResult.getResult();
      const count = messages.length;
      if (count < limit) {
        this.result = initialResult;
      } else {
        if (this.params.order === import_communication_types.SortingOrder.Ascending) {
          this.result = new import_result.QueryResult(messages.slice(0, limit), (x) => x.id);
          this.result.setHead(this.params.from == null);
          this.result.setTail(false);
        } else {
          this.result = new import_result.QueryResult(messages.slice(0, limit), (x) => x.id);
          this.result.setHead(false);
          this.result.setTail(this.params.from == null);
        }
      }
      this.initialized = true;
      void this.notify();
    } else {
      this.result = new import_result.QueryResult([], (x) => x.id);
      if (this.isInitLoadingForward()) {
        this.result.setHead(this.params.from == null);
        void this.requestLoadNextPage();
      } else {
        this.result.setTail(this.params.from == null);
        void this.requestLoadPrevPage();
      }
    }
  }
  static {
    __name(this, "MessagesQuery");
  }
  result;
  groups = [];
  areGroupsLoaded = false;
  groupsPromise;
  initialized = false;
  nexLoadedPagesCount = 0;
  prevLoadedPagesCount = 0;
  next = {
    done: false,
    buffer: [],
    lastGroupIndex: -1
  };
  prev = {
    done: false,
    buffer: [],
    lastGroupIndex: -1
  };
  tmpMessages = /* @__PURE__ */ new Map();
  isCardRemoved = false;
  findGroupIndex(groups, from) {
    const match = groups.findIndex(
      (it) => it.fromDate.getTime() <= from.getTime() && it.toDate.getTime() >= from.getTime()
    );
    if (match !== -1) return match;
    return groups.findIndex((it) => it.fromDate.getTime() >= from.getTime());
  }
  async loadGroups() {
    if (this.areGroupsLoaded) return;
    if (this.groupsPromise instanceof Promise) {
      await this.groupsPromise;
      this.groupsPromise = void 0;
      return;
    }
    const promise = (async () => {
      try {
        const res = await this.hulylake.getJson(`${this.params.cardId}/messages/groups`, {
          maxRetries: 3,
          isRetryable: /* @__PURE__ */ __name(() => true, "isRetryable"),
          delayStrategy: {
            getDelay: /* @__PURE__ */ __name(() => 500, "getDelay")
          }
        });
        let groups = Object.values(res?.body ?? {}).map((it) => ({
          cardId: this.params.cardId,
          count: it.count,
          blobId: it.blobId,
          fromDate: new Date(it.fromDate),
          toDate: new Date(it.toDate)
        })).sort((a, b) => a.fromDate.getTime() - b.fromDate.getTime());
        if (this.isOneMessageQuery(this.params)) {
          const blobId = this.params.blobId ?? (await this.client.findMessagesMeta({ cardId: this.params.cardId, id: this.params.id }))[0]?.blobId;
          if (blobId != null) {
            groups = groups.filter((it) => it.blobId === blobId);
          } else {
            groups = [];
          }
        }
        this.prev.lastGroupIndex = groups.length;
        const from = this.params.from;
        const fromGroupIndex = from != null ? this.findGroupIndex(groups, from) : null;
        if (fromGroupIndex != null) {
          if (this.params.order === import_communication_types.SortingOrder.Ascending) {
            this.next.lastGroupIndex = Math.max(-1, fromGroupIndex - 1);
            this.prev.lastGroupIndex = Math.max(-1, fromGroupIndex);
          } else {
            this.next.lastGroupIndex = Math.max(-1, fromGroupIndex);
            this.prev.lastGroupIndex = Math.max(-1, fromGroupIndex + 1);
          }
          if (fromGroupIndex === 0) {
            if (this.params.order === import_communication_types.SortingOrder.Ascending) {
              this.prev.done = true;
            }
          }
          if (fromGroupIndex === -1) {
            this.next.done = true;
            this.prev.lastGroupIndex = groups.length;
          }
        }
        this.areGroupsLoaded = true;
        return groups;
      } catch (e) {
        console.error(e);
      }
      return [];
    })();
    this.groupsPromise = promise;
    this.groups = await promise;
  }
  async onEvent(event) {
    if (this.isCardRemoved) return;
    switch (event.type) {
      case import_communication_sdk_types.MessageEventType.CreateMessage: {
        await this.onMessageCreatedEvent(event);
        break;
      }
      case import_communication_sdk_types.MessageEventType.UpdatePatch:
      case import_communication_sdk_types.MessageEventType.RemovePatch:
      case import_communication_sdk_types.MessageEventType.ThreadPatch:
      case import_communication_sdk_types.MessageEventType.BlobPatch:
      case import_communication_sdk_types.MessageEventType.AttachmentPatch:
      case import_communication_sdk_types.MessageEventType.ReactionPatch: {
        await this.onPatchEvent(event);
        break;
      }
      case import_communication_sdk_types.CardEventType.RemoveCard:
        await this.onCardRemoved(event);
        break;
    }
  }
  async onCardRemoved(event) {
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.params.cardId === event.cardId) {
      this.isCardRemoved = true;
      this.result.deleteAll();
      this.result.setHead(true);
      this.result.setTail(true);
      this.groups = [];
      void this.notify();
      return;
    }
    if (this.options?.threads === true) {
      const result = this.result.getResult();
      let isUpdated = false;
      for (const message of result) {
        if (message.threads.length > 0 && message.threads.some((it) => it.threadId === event.cardId)) {
          this.result.update({
            ...message,
            threads: message.threads.filter((it) => it.threadId !== event.cardId)
          });
          isUpdated = true;
        }
      }
      if (isUpdated) {
        void this.notify();
      }
    }
  }
  async onRequest(event, promise) {
    if (this.isCardRemoved) return;
    switch (event.type) {
      case import_communication_sdk_types.MessageEventType.CreateMessage: {
        await this.onCreateMessageRequest(event, promise);
        break;
      }
    }
  }
  async onCreateMessageRequest(event, promise) {
    if (this.params.cardId !== event.cardId) return;
    if (this.options?.autoExpand !== true) return;
    const eventId = event._id;
    if (eventId == null) return;
    const tmpId = event.messageId ?? (0, import_uuid.v4)();
    const tmpMessage = import_communication_shared.MessageProcessor.create(event, tmpId);
    let resultId;
    if (!this.match(tmpMessage)) return;
    promise.then(async (result) => {
      if (tmpId === result.messageId) return;
      this.tmpMessages.delete(eventId);
      resultId = result.messageId;
      if (this.result instanceof Promise) this.result = await this.result;
      if (this.result.get(resultId) != null) {
        if (this.result.delete(tmpId) != null) {
          await this.notify();
        }
      } else {
        const updatedMessage = { ...tmpMessage, id: resultId };
        this.result.delete(tmpId);
        this.insertMessage(this.result, updatedMessage);
        this.resort(this.result);
        void this.notify();
      }
    }).catch(async () => {
      if (this.result instanceof Promise) this.result = await this.result;
      this.tmpMessages.delete(eventId);
      if (this.result.delete(tmpId) != null) {
        void this.notify();
      }
    });
    if (this.result instanceof Promise) this.result = await this.result;
    if (resultId === void 0 && this.result.isTail()) {
      this.tmpMessages.set(eventId, tmpId);
      this.insertMessage(this.result, tmpMessage);
      this.resort(this.result);
      void this.notify();
    }
  }
  insertMessage(result, message) {
    if (this.params.order === import_communication_types.SortingOrder.Ascending) {
      result.push(message);
    } else {
      result.unshift(message);
    }
  }
  async subscribe() {
    await this.client.subscribeCard(this.params.cardId, this.id);
  }
  async unsubscribe() {
    await this.client.unsubscribeCard(this.params.cardId, this.id);
  }
  async requestLoadNextPage(notify = true) {
    if (this.isCardRemoved) return { isDone: true };
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.result.isTail()) return { isDone: true };
    const pagePromise = this.loadPage(import_types.Direction.Forward, this.result);
    this.nexLoadedPagesCount++;
    this.result = pagePromise;
    const r = await pagePromise;
    if (notify) {
      await this.notify();
    }
    return { isDone: r.isTail() };
  }
  async requestLoadPrevPage(notify = true) {
    if (this.isCardRemoved) return { isDone: true };
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.result.isHead()) return { isDone: true };
    const pagePromise = this.loadPage(import_types.Direction.Backward, this.result);
    this.prevLoadedPagesCount++;
    this.result = pagePromise;
    const r = await pagePromise;
    if (notify) {
      await this.notify();
    }
    return { isDone: r.isHead() };
  }
  removeCallback() {
    this.callback = () => {
    };
  }
  setCallback(callback) {
    this.callback = callback;
    void this.notify();
  }
  copyResult() {
    if (this.result instanceof Promise) {
      return void 0;
    }
    return this.result.copy();
  }
  isInitLoadingForward() {
    const { order } = this.params;
    if (this.isOneMessageQuery(this.params)) {
      return true;
    }
    return order === import_communication_types.SortingOrder.Ascending;
  }
  async loadPage(direction, result) {
    if (!this.areGroupsLoaded) {
      await this.loadGroups();
    }
    const limit = this.getLimit();
    const messages = direction === import_types.Direction.Forward ? await this.loadNextMessages(result) : await this.loadPrevMessages(result);
    if (!result.isHead() && direction === import_types.Direction.Backward) {
      result.setHead(messages.length < limit);
    }
    if (!result.isTail() && direction === import_types.Direction.Forward) {
      result.setTail(messages.length < limit);
    }
    if (this.next.done && this.next.buffer.length === 0) {
      result.setTail(true);
    }
    if (this.prev.done && this.prev.buffer.length === 0) {
      result.setHead(true);
    }
    if (this.params.order === import_communication_types.SortingOrder.Ascending && direction === import_types.Direction.Backward) {
      result.prepend(messages.reverse());
    } else if (this.params.order === import_communication_types.SortingOrder.Descending && direction === import_types.Direction.Forward) {
      result.prepend(messages.reverse());
    } else {
      result.append(messages);
    }
    return result;
  }
  getLimit() {
    return this.params.limit ?? import_types.defaultQueryParams.limit;
  }
  // Load next
  async loadNextMessages(result) {
    const limit = this.getLimit();
    const messages = this.next.buffer.splice(0, limit);
    if (messages.length >= limit) return messages;
    while (!this.next.done) {
      await this.fillMessagesBuffer(import_types.Direction.Forward, result);
      const restLimit = limit - messages.length;
      if (restLimit <= 0) break;
      const fromBuffer = this.next.buffer.splice(0, restLimit);
      messages.push(...fromBuffer);
      if (messages.length >= limit) return messages;
    }
    return messages;
  }
  // Load prev
  async loadPrevMessages(result) {
    const limit = this.getLimit();
    const messages = this.prev.buffer.splice(-limit).reverse();
    if (messages.length >= limit) return messages;
    while (!this.prev.done) {
      await this.fillMessagesBuffer(import_types.Direction.Backward, result);
      const restLimit = limit - messages.length;
      if (restLimit <= 0) break;
      const fromBuffer = this.prev.buffer.splice(-restLimit).reverse();
      messages.push(...fromBuffer);
      if (messages.length >= limit) return messages;
    }
    return messages;
  }
  getNextGroupsToLoad(last) {
    const limit = this.getLimit();
    const groupsToLoad = [];
    let count = 0;
    let i = this.next.lastGroupIndex + 1;
    if (i >= this.groups.length) {
      this.next.done = true;
      return groupsToLoad;
    }
    for (; i < this.groups.length; i++) {
      if (count >= limit) break;
      const group = this.groups[i];
      if (last != null && group.toDate.getTime() < last.created.getTime()) continue;
      groupsToLoad.push(group);
      count += group.count;
    }
    this.next.lastGroupIndex = i - 1;
    this.next.done = this.next.lastGroupIndex >= this.groups.length - 1;
    return groupsToLoad;
  }
  getPrevGroupsToLoad(first) {
    const limit = this.getLimit();
    let count = 0;
    const groupsToLoad = [];
    let i = this.prev.lastGroupIndex - 1;
    if (i < 0) {
      this.prev.done = true;
      return groupsToLoad;
    }
    for (; i >= 0; i--) {
      if (count >= limit) break;
      const group = this.groups[i];
      if (first != null && group.fromDate.getTime() > first.created.getTime()) continue;
      groupsToLoad.push(group);
      count += group.count;
    }
    this.prev.lastGroupIndex = i + 1;
    this.prev.done = this.prev.lastGroupIndex <= 0;
    return groupsToLoad;
  }
  async fillMessagesBuffer(direction, result) {
    const groups = direction === import_types.Direction.Forward ? this.getNextGroupsToLoad(result.getLast()) : this.getPrevGroupsToLoad(result.getFirst()).reverse();
    const messages = await Promise.all(groups.map((group) => this.loadMessagesFromBlob(group.blobId)));
    const matched = this.matchMessages(
      messages.flat(),
      direction,
      this.params.order === import_communication_types.SortingOrder.Ascending ? result.getFirst() : result.getLast()
    );
    if (direction === import_types.Direction.Forward) {
      this.next.buffer.push(...matched.next);
      this.prev.buffer.push(...matched.prev);
    } else {
      this.prev.buffer.unshift(...matched.prev);
      this.next.buffer.push(...matched.next);
    }
  }
  matchMessages(messages, direction, currentFirst) {
    const params = this.params;
    const _messages = this.isOneMessageQuery(params) ? [messages.find((it) => it.id === params.id)].filter((it) => it != null) : messages;
    let prev = [];
    let next = [];
    const from = this.initialized ? void 0 : this.params.from;
    const lastMessage = _messages[_messages.length - 1];
    if (from instanceof Date) {
      for (const message of _messages) {
        const isNext = params.order === import_communication_types.SortingOrder.Ascending ? message.created >= from : message.created > from;
        if (isNext) {
          next.push(message);
        } else {
          prev.push(message);
        }
      }
    } else if (direction === import_types.Direction.Backward && (currentFirst == null || lastMessage.created < currentFirst.created)) {
      prev = _messages;
    } else {
      next = _messages;
    }
    return { next, prev };
  }
  async loadMessagesFromBlob(blobId) {
    const params = this.isOneMessageQuery(this.params) ? { cardId: this.params.cardId, id: this.params.id, order: import_communication_types.SortingOrder.Ascending } : { cardId: this.params.cardId, order: import_communication_types.SortingOrder.Ascending };
    return await (0, import_utils.loadMessages)(this.hulylake, this.params.cardId, blobId, params, this.options);
  }
  isOneMessageQuery(params) {
    return "id" in this.params && this.params.id != null;
  }
  async notify() {
    this.initialized = true;
    if (this.callback == null) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const result = this.result.getResult();
    this.callback(new import_window.WindowImpl(result, this.result.getTotal(), this.result.isTail(), this.result.isHead(), this));
  }
  match(message) {
    if (this.params.cardId !== message.cardId) {
      return false;
    }
    if (this.isOneMessageQuery(this.params) && this.params.id !== message.id) {
      return false;
    }
    return true;
  }
  resort(result) {
    result.sort(
      (a, b) => this.params.order === import_communication_types.SortingOrder.Ascending ? a.created.getTime() - b.created.getTime() : b.created.getTime() - a.created.getTime()
    );
  }
  async onMessageCreatedEvent(event) {
    if (this.params.cardId !== event.cardId || event.messageId == null) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const limit = this.getLimit();
    const count = this.result.length;
    const message = import_communication_shared.MessageProcessor.create(event);
    const exists = this.result.get(message.id);
    if (exists !== void 0) return;
    if (!this.match(message)) return;
    const autoExpand = this.options?.autoExpand ?? false;
    const last = this.params.order === import_communication_types.SortingOrder.Ascending ? this.result.getLast() : this.result.getFirst();
    const fromTail = message.created.getTime() >= (last?.created.getTime() ?? 0);
    if (!autoExpand) {
      this.result.unshift(message);
      this.resort(this.result);
      if (count >= limit && this.params.order === import_communication_types.SortingOrder.Descending) {
        this.result.pop();
      } else if (count >= limit && this.params.order === import_communication_types.SortingOrder.Ascending) {
        this.result.shift();
      }
      await this.notify();
      return;
    }
    const eventId = event._id;
    if (eventId != null) {
      const tmp = this.tmpMessages.get(eventId);
      if (tmp != null) this.result.delete(tmp);
      this.tmpMessages.delete(eventId);
    }
    if (this.result.isTail() && fromTail) {
      if (this.params.order === import_communication_types.SortingOrder.Ascending) {
        this.result.push(message);
      } else {
        this.result.unshift(message);
      }
      this.resort(this.result);
      await this.notify();
    } else if (!fromTail) {
      this.result.push(message);
      this.resort(this.result);
      if (!this.result.isTail() && this.params.order === import_communication_types.SortingOrder.Descending) {
        this.result.pop();
      } else if (!this.result.isTail() && this.params.order === import_communication_types.SortingOrder.Ascending) {
        this.result.shift();
      }
      await this.notify();
    }
  }
  async onPatchEvent(event) {
    if (this.params.cardId !== event.cardId) return;
    const allowedPatchEvents = this.allowedPatchEvents();
    if (!allowedPatchEvents.includes(event.type)) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const { messageId } = event;
    const message = this.result.get(messageId);
    const count = this.result.length;
    const limit = this.getLimit();
    if (message !== void 0) {
      const updatedMessage = import_communication_shared.MessageProcessor.applyPatch(message, event);
      if (updatedMessage != null) {
        this.result.update(updatedMessage);
      } else {
        this.result.delete(messageId);
        if (this.options?.autoExpand !== true && count === limit) {
          await this.refresh();
          return;
        }
      }
      await this.notify();
    } else {
      this.next.buffer = this.next.buffer.map((it) => {
        if (it.id === event.messageId) {
          return import_communication_shared.MessageProcessor.applyPatch(it, event);
        }
        return it;
      }).filter((it) => it != null);
      this.prev.buffer = this.next.buffer.map((it) => {
        if (it.id === event.messageId) {
          return import_communication_shared.MessageProcessor.applyPatch(it, event);
        }
        return it;
      }).filter((it) => it != null);
    }
  }
  allowedPatchEvents() {
    const result = [import_communication_sdk_types.MessageEventType.UpdatePatch, import_communication_sdk_types.MessageEventType.RemovePatch];
    if (this.options?.reactions === true) {
      result.push(import_communication_sdk_types.MessageEventType.ReactionPatch);
    }
    if (this.options?.attachments === true) {
      result.push(import_communication_sdk_types.MessageEventType.AttachmentPatch);
      result.push(import_communication_sdk_types.MessageEventType.BlobPatch);
    }
    if (this.options?.threads === true) {
      result.push(import_communication_sdk_types.MessageEventType.ThreadPatch);
    }
    return result;
  }
  async refresh() {
    const nextPagesCount = this.nexLoadedPagesCount;
    const prevPagesCount = this.prevLoadedPagesCount;
    this.areGroupsLoaded = false;
    this.groups = [];
    this.groupsPromise = void 0;
    this.nexLoadedPagesCount = 0;
    this.prevLoadedPagesCount = 0;
    this.next.done = false;
    this.next.buffer = [];
    this.prev.lastGroupIndex = -1;
    this.prev.done = false;
    this.prev.buffer = [];
    this.prev.lastGroupIndex = -1;
    this.tmpMessages.clear();
    this.result = new import_result.QueryResult([], (x) => x.id);
    this.initialized = false;
    void this.subscribe();
    if (this.isInitLoadingForward()) {
      this.result.setHead(this.params.from == null);
    } else {
      this.result.setTail(this.params.from == null);
    }
    for (let i = 0; i < nextPagesCount; i++) {
      const { isDone } = await this.requestLoadNextPage(false);
      this.initialized = true;
      if (!isDone) break;
    }
    for (let i = 0; i < prevPagesCount; i++) {
      const { isDone } = await this.requestLoadPrevPage(false);
      this.initialized = true;
      if (!isDone) break;
    }
    await this.notify();
  }
}
//# sourceMappingURL=query.js.map
